import { ApiEndpoints } from '../../constants/ApiEndpoints';
import { baseRequest } from '../../utils/HttpClient';

export const getUserActivity = (pathParams, queryParams) => {
  return baseRequest(ApiEndpoints.GET_USER_ACTIVITY, null, pathParams, queryParams);
};
